// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__sqJYc","col":"styles_col__3iuZJ"};